<template>
  <div class="carkit">
    <carkit-container></carkit-container>
  </div>
</template>
<script>
import CarkitContainer from '@/components/carkit/Container.vue'
export default {
  name: 'carkit',
  components: {
    CarkitContainer
  }
}
</script>
<style lang="stylus">
  .carkit
    height 100%
    padding 20px
</style>
